import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { Header } from '../../components/header/header';
import { Footer } from '../../components/footer/footer';
import { BookingModal } from '../../components/booking-modal/booking-modal';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-home-layout',
  imports: [RouterOutlet, Header, Footer, BookingModal],
  templateUrl: './home-layout.html',
  styleUrl: './home-layout.css',
})
export class HomeLayout implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;
  showBookingModal = signal(false);

  constructor(private router: Router) {}

  ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // Scroll to top on navigation with small delay for content to load
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, 0);
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  openBookingModal() {
    this.showBookingModal.set(true);
  }

  closeBookingModal() {
    this.showBookingModal.set(false);
  }
}
